import { render } from "./ReleaseEditComponent.vue?vue&type=template&id=1a95646d&scoped=true"
import script from "./ReleaseEditComponent.vue?vue&type=script&lang=js"
export * from "./ReleaseEditComponent.vue?vue&type=script&lang=js"

import "./ReleaseEditComponent.vue?vue&type=style&index=0&id=1a95646d&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a95646d"]])

export default __exports__